<template>
  <div>
    <Head title="Собственники" />
    <h1 class="mb-8 text-3xl font-bold">Собственники</h1>
    <div class="mb-6 flex items-center justify-between">
      <search-filter
        v-model="form.search"
        class="mr-4 w-full max-w-md"
        @reset="reset"
      >
        <label class="block text-gray-800" for="trashed-filter">
          Удаленные:
        </label>
        <select
          id="trashed-filter"
          v-model="form.trashed"
          class="form-select mt-1 w-full"
        >
          <option :value="null" />
          <option value="with">С Удаленными</option>
          <option value="only">Только Удаленные</option>
        </select>
      </search-filter>

      <button class="btn-indigo" @click="modalNew = true">
        Добавить <span class="hidden md:inline">Собственника</span>
      </button>
      <modal
        :open="modalNew"
        title="Добавить Собственника"
        @close="modalNew = false"
      >
        <new-client :houses="houses" @success="modalNew = false" />
      </modal>
    </div>
    <div class="overflow-x-auto rounded bg-white shadow">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="px-6 pb-4 pt-6">Собственник</th>
            <th class="px-6 pb-4 pt-6">Адрес</th>
            <th class="px-6 pb-4 pt-6">Телефон</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="client in clients.data"
            :key="client.id"
            class="focus-within:bg-gray-100 hover:bg-gray-100"
          >
            <td class="border-t">
              <Link
                class="flex items-center px-6 py-4 focus:text-indigo-500"
                :href="$routes.edit_client(client.id)"
              >
                {{ client.name }}
                <icon
                  v-if="client.deleted_at"
                  name="trash"
                  class="ml-2 h-3 w-3 flex-shrink-0 fill-gray-500"
                />
              </Link>
            </td>
            <td class="border-t">
              <Link
                class="flex items-center px-6 py-4"
                :href="$routes.edit_client(client.id)"
                tabindex="-1"
                aria-label="Edit"
              >
                {{ client.address }}
              </Link>
            </td>
            <td class="border-t">
              <Link
                class="flex items-center px-6 py-4"
                :href="$routes.edit_client(client.id)"
                tabindex="-1"
                aria-label="Edit"
              >
                {{ client.phone }}
              </Link>
            </td>
            <td class="w-px border-t">
              <Link
                class="flex items-center px-4"
                :href="$routes.edit_client(client.id)"
                tabindex="-1"
                aria-label="Edit"
              >
                <icon
                  name="cheveron-right"
                  class="block h-6 w-6 fill-gray-500"
                />
              </Link>
            </td>
          </tr>
          <tr v-if="clients.data.length === 0">
            <td class="border-t px-6 py-4" colspan="3">
              Не найдено собственников.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination :meta="clients.meta" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3';
import Icon from '@/Shared/Icon.vue';
import Layout from '@/Layouts/Main.vue';
import mapValues from 'lodash/mapValues';
import Pagination from '@/Shared/Pagination.vue';
import pickBy from 'lodash/pickBy';
import SearchFilter from '@/Shared/SearchFilter.vue';
import Modal from '@/Shared/Modal.vue';
import NewClient from '@/Pages/Clients/_New.vue';
import throttle from 'lodash/throttle';

export default {
  components: {
    Head,
    Link,
    Icon,
    Pagination,
    SearchFilter,
    Modal,
    NewClient,
  },
  layout: Layout,
  props: {
    clients: {
      type: Object,
      required: true,
    },
    houses: {
      type: Array,
      required: true,
    },
    filters: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
      modalNew: false,
    };
  },
  watch: {
    form: {
      handler: throttle(function () {
        let query = pickBy(this.form);
        this.$inertia.get(
          this.$routes.clients(
            Object.keys(query).length ? query : { remember: 'forget' },
          ),
          {},
          {
            preserveState: true,
            preserveScroll: true,
            replace: true,
            only: ['clients'],
          },
        );
      }, 150),
      deep: true,
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null);
    },
  },
};
</script>
